module.exports = __webpack_public_path__ + "static/media/3 6 tattoo chest neck demon monster macabre dark realism.1280x1707.f0e344a0.webp";